export { default } from './Module'


// WEBPACK FOOTER //
// ./src/components/Content/Module/index.js